import Link from 'next/link'

import { getSocialPlatform } from '@/lib/social-platforms'
import { resolveMediaDefaultSocialLinks } from '@/lib/tenant-media-defaults'
import { cn } from '@/lib/utils'
import { useBrandingHostname } from '@/hooks/use-branding'
import { useTenantConfig } from '@/hooks/use-tenant-config'

import { isOnFullstackdatascienceDomainFromRequest } from '@/utils/tenant.utils'

interface FooterSocialIconLinksProps {
  showSocialLinks: boolean
  className?: string
}

export function FooterSocialIconLinks({ showSocialLinks, className }: FooterSocialIconLinksProps) {
  const hostname = useBrandingHostname()
  const { customization } = useTenantConfig()

  if (isOnFullstackdatascienceDomainFromRequest(hostname) || !showSocialLinks) {
    return null
  }

  const links = resolveMediaDefaultSocialLinks(customization)
  if (!links.length) {
    return null
  }

  return (
    <div className={cn('flex shrink-0 flex-wrap items-center gap-1', className)}>
      {links.map(link => {
        const platform = getSocialPlatform(link.platform)
        if (!platform) {
          return null
        }
        const Icon = platform.icon
        return (
          <Link
            key={link.platform}
            href={link.url}
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex size-9 items-center justify-center rounded-full text-muted-foreground transition-colors hover:bg-muted hover:text-foreground"
            aria-label={platform.label}
          >
            <Icon className="size-4" aria-hidden />
          </Link>
        )
      })}
    </div>
  )
}
